import { render } from "./PermissionCommon.vue?vue&type=template&id=b08d81a8&ts=true"
import script from "./PermissionCommon.vue?vue&type=script&lang=ts"
export * from "./PermissionCommon.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-distribution-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__